import React, { useState, useEffect } from "react";
import Sidebar from "../../components/MasterSideBar";
import Topbar from "../../components/TopbarNav";
import ReportCaseForm from "../../components/ReportCaseForm";
import MyCases from "../../components/MyCases";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HODiscipline = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [userId, setUserId] = useState(null);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUserId(parsedUser.id || parsedUser.userId);
            } catch (err) {
                console.error("Error parsing user from localStorage:", err);
            }
        }
    }, []);

    if (!userId) {
        return <div>Loading user data...</div>;
    }

    return (
        <div className="flex min-h-screen bg-gray-100 font-sans">
            {/* Sidebar */}
            <Sidebar visible={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            {/* Main Area */}
            <div className="flex flex-col flex-1 md:ml-64">
                <Topbar onSidebarToggle={() => setSidebarOpen(true)} />

                <main className="flex-1 p-6 space-y-8 pt-20 overflow-y-auto">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
                        <h1 className="text-2xl font-bold text-gray-800">My Disciplinary Cases</h1>
                        <button
                            onClick={() => setShowForm(true)}
                            className="bg-orange-500 text-white px-4 py-2 rounded shadow hover:bg-orange-600 transition"
                        >
                            Report a New Case
                        </button>
                    </div>

                    {/* Modal / Drawer for the Report Form */}
                    {showForm && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
                            <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative overflow-y-auto max-h-[90vh]">
                                <button
                                    onClick={() => setShowForm(false)}
                                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
                                >
                                    &times;
                                </button>
                                <h2 className="text-xl font-semibold mb-4 text-orange-600">
                                    Report a New Case
                                </h2>
                                <ReportCaseForm
                                    reporterId={userId}
                                    onClose={() => {
                                        setShowForm(false);
                                        toast.success("Case reported successfully! It is now awaiting review.", {
                                            position: "top-center",
                                            autoClose: 4000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                            style: {
                                                background: "#FFEDD5",
                                                color: "#92400E",
                                                fontWeight: "500",
                                                fontSize: "16px",
                                                textAlign: "center",
                                                borderRadius: "8px",
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {/* Component to display their cases */}
                    <MyCases userId={userId} />

                    {/* Toast container */}
                    <ToastContainer />
                </main>
            </div>
        </div>
    );
};

export default HODiscipline;
